import * as React from 'react';
import { DialogStateProvider } from './dialog-state';
var defaultComponentFactory = function (isOpen) {
  return function (props) {
    return React.createElement(React.Fragment, null, isOpen && props.children);
  };
};
var defaults = {
  useDialogControl: function (id, dialogQueryKey, isOpen, setIsOpen) {
    return {
      ComponentFactory: defaultComponentFactory(isOpen),
      actions: {
        openDialog: function (options) {
          return setIsOpen(true, options === null || options === void 0 ? void 0 : options.closeAllDialogs);
        },
        closeDialog: function (options) {
          return setIsOpen(false, options === null || options === void 0 ? void 0 : options.closeAllDialogs);
        },
        toggleDialog: function (options) {
          return setIsOpen(!isOpen, options === null || options === void 0 ? void 0 : options.closeAllDialogs);
        }
      }
    };
  }
};
/**
 * @protected
 */
export var DialogControlContext = React.createContext(defaults);
export var DialogControlProvider = function (_a) {
  var value = _a.value,
    children = _a.children;
  return React.createElement(DialogStateProvider, null, React.createElement(DialogControlContext.Provider, {
    value: value
  }, children));
};